module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAARCAYAAADg1u3YAAAA0klEQVQoU9WQMQrCUAyG/2Syo3gDJwVn8QbewF3Xbn1RBFcXyytdXfQCHsETuCqCIugiODh5gDbyipWHiLv/EpJ8/PwJ4SUR6QGYA6iWM1W9kWvCMKwFQXAFUCmXrhLRuQBEpA9g6S0dvFXVRwEYY0ZENPOAjrV2U7i8HIYAYg+oW2svBWCMWQBoEVHbA1bOnpkfJCLqB/sIufsJqOqaoigaMHMXgPtDqXGe53dVPX0NycyNOI6P7ys+z1TVZpIkh/8CRGQCYFo+IcuyVpqme9c/AVFedEul/P9rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-Facebook.png
// module id = X9G6
// module chunks = 1